<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <Mlogin />
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">联系我们</div>
                  <div class="title_more2"><a href="">首页</a>>联系我们</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="xbjj_con" style="padding: 10px">
                    <p>地 址：西安市劳动南路210号5-1-3信箱</p>
                    <p>邮 编：710082</p>
                    <p>电 话：029-84350396</p>
                    <p>传 真：029-84350396</p>
                    <p>邮 件：<a href="">dzsjgc@126.com</a></p>
                    <p class="red">
                      注：投稿时请务必在“在线投稿系统”中进行投稿！
                    </p>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
    }
  },
  components: {},
  methods: {},
}
</script>

<style scoped></style>
